export default "__VITE_ASSET__BI9zo8Fk__"